import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { Stack, Typography } from "@mui/material";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch, FC } from "react";

export interface BrandFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  t: (key: string) => string;
}

export const BrandFilter: FC<BrandFilterProps> = ({
  value = [],
  onChange,
  t,
}) => {
  return (
    <ColorSearchAutocomplete
      label={t("filter_grade_brand")}
      type="brand"
      example={t("filter_grade_brand_example")}
      value={value}
      onChange={onChange}
      limit={50}
      formatOptionLabel={(option) => option.value}
      formatOptionText={(option) => (
        <Stack
          direction="row"
          width="100%"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography>{option.value}</Typography>
          <Typography
            color="text.secondary"
            fontSize="var(--body-b3-12-regular-size, 12px)"
            fontStyle="italic"
            align="right"
            sx={{ maxWidth: "80%" }}
          >
            {option.description}
          </Typography>
        </Stack>
      )}
    />
  );
};
